import { render, staticRenderFns } from "./ClassRoomEdit.vue?vue&type=template&id=65a3debd&scoped=true&"
import script from "./ClassRoomEdit.vue?vue&type=script&lang=js&"
export * from "./ClassRoomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3debd",
  null
  
)

export default component.exports